import { Button, Grid, Typography } from "@mui/material";
import { DtDialog, DtStatusDialog } from "./ui/dialog";
import DtAlert from "./ui/alert/DtAlert";

interface AdminSetupModalProps {
    open: boolean;
    onClose: () => void;
    text: string;
    isAdmin: boolean;
}

const AdminSetupModal: React.FC<AdminSetupModalProps> = ({ open, onClose, text, isAdmin }) => {

    return (
        <>
            <DtStatusDialog
                open={open}
                onClose={onClose}
                title="Setup Needed"
                status="error"
                isClosable={false}
                message={<Grid item gap={2}>
                    {!isAdmin ?
                        <Typography variant="h6">
                            Please contact your administrator.
                        </Typography> : <></>}
                    <DtAlert icon={<></>} severity="error" sx={{mt: 1}}>
                        Error Details: {text}
                    </DtAlert>
                </Grid>}
            />
        </>
    )
}

export default AdminSetupModal;